export default __webpack_public_path__ + "static/media/LogoIcon.79de9d48.svg";